import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="text-2xl font-bold text-primary-400">
              🏥 Sharma Ortho Center
            </div>
            <p className="text-gray-300 text-sm leading-6">
              Providing world-class orthopedic treatments with compassionate care. 
              Your health and recovery are our top priorities.
            </p>
            <div className="flex space-x-4">
              <Facebook className="h-6 w-6 text-gray-300 hover:text-primary-400 cursor-pointer transition-colors" />
              <Instagram className="h-6 w-6 text-gray-300 hover:text-primary-400 cursor-pointer transition-colors" />
              <Linkedin className="h-6 w-6 text-gray-300 hover:text-primary-400 cursor-pointer transition-colors" />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-primary-400 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-primary-400 transition-colors">About Us</Link></li>
              <li><Link to="/specialty" className="text-gray-300 hover:text-primary-400 transition-colors">Specialty</Link></li>
              <li><Link to="/team" className="text-gray-300 hover:text-primary-400 transition-colors">Our Team</Link></li>
              <li><Link to="/testimonials" className="text-gray-300 hover:text-primary-400 transition-colors">Testimonials</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><span className="text-gray-300">Joint Replacement</span></li>
              <li><span className="text-gray-300">Sports Injury</span></li>
              <li><span className="text-gray-300">Physiotherapy</span></li>
              <li><span className="text-gray-300">Trauma Care</span></li>
              <li><span className="text-gray-300">Arthroscopy</span></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-primary-400 mt-1 flex-shrink-0" />
                <span className="text-gray-300 text-sm">
                  Kuchaman - Sikar - Didwana Rd, Tilak Nagar, Sikar, Rajasthan 332001
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-primary-400 flex-shrink-0" />
                <span className="text-gray-300 text-sm">+91 77270 48951</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-primary-400 flex-shrink-0" />
                <span className="text-gray-300 text-sm">info@sharmaortho.com</span>
              </div>
              <div className="mt-4">
                <span className="text-sm text-gray-300">
                  <strong>Hours:</strong> Mon-Sat: 9:00 AM - 7:00 PM
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-300 text-sm mb-4 md:mb-0">
              © 2025 Sharma Ortho Center and Hospital. All rights reserved.
            </div>
            <div className="flex space-x-6 text-sm">
              <Link to="/terms" className="text-gray-300 hover:text-primary-400 transition-colors">
                Terms & Conditions
              </Link>
              <Link to="/privacy" className="text-gray-300 hover:text-primary-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/career" className="text-gray-300 hover:text-primary-400 transition-colors">
                Careers
              </Link>
              <Link to="/contact" className="text-gray-300 hover:text-primary-400 transition-colors">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
